import { render, staticRenderFns } from "./CragHead.vue?vue&type=template&id=0f833a7d&scoped=true"
import script from "./CragHead.vue?vue&type=script&lang=js"
export * from "./CragHead.vue?vue&type=script&lang=js"
import style0 from "./CragHead.vue?vue&type=style&index=0&id=0f833a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f833a7d",
  null
  
)

export default component.exports